// ImageComponent.js
import React from 'react';
import imgPorDefecto from '../../assets/img_lineas_productivas/pordefecto.png';
import img1 from '../../assets/img_lineas_productivas/AraucaCerdosCHP.jpeg';
import img2 from '../../assets/img_lineas_productivas/AraucaPisciculturaAfpaz.jpeg';
import img3 from '../../assets/img_lineas_productivas/CaucaAsomanuelitas.jpg';
import img4 from '../../assets/img_lineas_productivas/CaucaCerdosCoomep.jpeg';
import img5 from '../../assets/img_lineas_productivas/CaucaCerdosCoopatia.jpg';
import img6 from '../../assets/img_lineas_productivas/CaucaGallinasAMIFP.jpg';
import img7 from '../../assets/img_lineas_productivas/CaucaPisciculturaCemas.jpeg';
import img8 from '../../assets/img_lineas_productivas/CaucaPisciculturaCoomep.jpg';
import img11 from '../../assets/img_lineas_productivas/HuilaCafeAsoemancipadoras.jpg';
import img12 from '../../assets/img_lineas_productivas/MetaCoomuldgGanaderia.jpeg';
import img13 from '../../assets/img_lineas_productivas/MetaGanaderiaCoopje.jpg';
import img14 from '../../assets/img_lineas_productivas/MetaGanaderiaDaincoop.jpg';
import img15 from '../../assets/img_lineas_productivas/MetaGanadoCooproAgrometa.jpeg';
import img17 from '../../assets/img_lineas_productivas/NarinoCacaoCoomuntu.jpg';
import img18 from '../../assets/img_lineas_productivas/NarinoPescaAsopesj.jpg';
import img19 from '../../assets/img_lineas_productivas/NarinoPisciculturaCoommave.jpg';
import img22 from '../../assets/img_lineas_productivas/TolimaCafeAcopaz.jpg';
import img23 from '../../assets/img_lineas_productivas/TolimaCafeComumarfu.jpg';
import img24 from '../../assets/img_lineas_productivas/TolimaCafeEPZ.jpg';
import img25 from '../../assets/img_lineas_productivas/HuilaCafeFedeagropaz.png';
import img26 from '../../assets/img_lineas_productivas/HuilaGanadoCooagropaz.png';
import img27 from '../../assets/img_lineas_productivas/MetaGanadoCoagrancc.png';
import img28 from '../../assets/img_lineas_productivas/NarinoPisciculturaComfrosur.png';



//Sin definir: 13 ASOCOLIB, 

const ImageComponent = ({ projectId }) => {

    const imageMapping = {
        1: img18,
        2: img17,
        3: img11,
        4: img26,
        5: img19,
        6: img13,
        7: img3,
        8: img2,
        9: img12,
        10: img8,
        11: img4,
        12: img25,
        13: imgPorDefecto,
        14: imgPorDefecto,
        15: img14,
        16: img24,
        17: img22,
        18: img1,
        19: img5,
        20: img7,
        21: img23,
        22: img28,
        23: img27,
        24: img5,
        25: img6,
        26: img15,
        27: imgPorDefecto,
        28: img28
    };

    // Obtén la imagen del proyecto o usa la imagen por defecto
    const imageSrc = imageMapping[projectId] || imgPorDefecto;

    return (
        <div
            style={{
                width: '100%',
                height: '110px',
                backgroundImage: `url(${imageSrc})`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                backgroundSize: 'cover',  // ← aquí
                margin: 0,                  // quita márgenes negativos
                transform: 'none',          // quita el scale
            }}
        />


    );
};

export default ImageComponent;
